import { render } from "./ProjectHeader.vue?vue&type=template&id=5283a8ed&scoped=true"
import script from "./ProjectHeader.vue?vue&type=script&lang=js"
export * from "./ProjectHeader.vue?vue&type=script&lang=js"

import "./ProjectHeader.vue?vue&type=style&index=0&id=5283a8ed&scoped=true&lang=css"

import exportComponent from "/home/yazgaroth/code/guinze/guinze.v3/agenda/v3/prod/frontend/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5283a8ed"]])

export default __exports__